<template>
    <div id="vMenu">
        <div class="list-group list-group-flush panel">
            <b-list-group-item
                :href="menuRoutes['deadlines']"
                class="item"
                :active="pageName === 'deadlines'"
                data-parent="#vMenu"
                @click="setPageName('deadlines')"
            ><i class="fa-fw fal fa-calendar-day menu-icon"/>Echéances
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="deadlinesCounter"
                        :values="counters.all"
                    />
                </div>
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['plannedTasks']"
                class="item"
                :active="pageName === 'plannedTasks'"
                data-parent="#vMenu"
                @click="setPageName('plannedTasks')"
            ><i class="fa-fw fal fa-calendar-day menu-icon"/>Planning
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['ten']"
                class="item"
                :active="pageName === 'ten'"
                data-parent="#vMenu"
                @click="setPageName('ten')"
            ><i class="fa-fw fal fa-table menu-icon"/>Tenue
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['sit']"
                class="item"
                :active="pageName === 'sit'"
                data-parent="#vMenu"
                @click="setPageName('sit')"
            ><i class="fa-fw fal fa-table menu-icon"/>Situations - Reporting
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="sitCounter"
                        :values="counters.sit"
                    />
                </div>
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['bil']"
                class="item"
                :active="pageName === 'bil'"
                data-parent="#vMenu"
                @click="setPageName('bil')"
            ><i class="fa-fw fal fa-table menu-icon"/>Bilan
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="bilCounter"
                        :values="counters.bil"
                    />
                </div>
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['vat']"
                class="item"
                :active="pageName === 'vat'"
                data-parent="#vMenu"
                @click="setPageName('vat')"
            ><i class="fa-fw fal fa-table menu-icon"/>TVA - TVS
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="vatCounter"
                        :values="counters.vat"
                    />
                </div>
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['iss']"
                class="item"
                :active="pageName === 'iss'"
                data-parent="#vMenu"
                @click="setPageName('iss')"
            ><i class="fa-fw fal fa-table menu-icon"/>IS
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="issCounter"
                        :values="counters.iss"
                    />
                </div>
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['dir']"
                class="item"
                :active="pageName === 'dir'"
                data-parent="#vMenu"
                @click="setPageName('dir')"
            >
                <i class="fa-fw fal fa-table menu-icon"/>IR
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="dirCounter"
                        :values="counters.dir"
                    />
                </div>
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['oth']"
                class="item"
                :active="pageName === 'oth'"
                data-parent="#vMenu"
                @click="initOthPage"
            >
                <i class="fa-fw fal fa-table menu-icon"/>Autres taxes
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="othCounter"
                        :values="counters.oth"
                    />
                </div>
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['otm']"
                class="item"
                :active="pageName === 'otm'"
                data-parent="#vMenu"
                @click="setPageName('otm')"
            >
                <i class="fa-fw fal fa-table menu-icon"/>Autres missions
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="othCounter"
                        :values="counters.otherMissions"
                    />
                </div>
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['prp']"
                class="item"
                :active="pageName === 'prp'"
                data-parent="#vMenu"
                @click="initOthPage"
            ><i class="fa-fw fal fa-table menu-icon"/>Prélèvement - Paiement

            </b-list-group-item>
            <!--            <a-->
            <!--                v-b-toggle.otherTax-->
            <!--                href="#"-->
            <!--                class="list-group-item item"-->
            <!--                :class="activeOtherTax"-->
            <!--            >-->
            <!--                <i class="fa-fw fal fa-table menu-icon" />Autres taxes&nbsp;<i-->
            <!--                    class="fa fa-caret-down"-->
            <!--                />-->
            <!--                <div class="float-right">-->
            <!--                    <counter-->
            <!--                        v-if="showCounters"-->
            <!--                        ref="otherTaxCounter"-->
            <!--                        :values="counters.otherTax"-->
            <!--                    />-->
            <!--                </div>-->
            <!--            </a>-->
            <!--            <b-collapse id="otherTax" :visible="openOtherTax">-->
            <!--                <b-list-group-item-->
            <!--                    :href="menuRoutes['cfe']"-->
            <!--                    class="item sub-item"-->
            <!--                    :active="pageName === 'cfe'"-->
            <!--                    @click="setPageName('cfe')"-->
            <!--                >-->
            <!--                    <i class="fa-fw fal fa-table menu-sub-icon" />CFE-->
            <!--                    <div class="float-right">-->
            <!--                        <counter-->
            <!--                            v-if="showCounters"-->
            <!--                            ref="cfeCounter"-->
            <!--                            :values="counters.cfe"-->
            <!--                        />-->
            <!--                    </div>-->
            <!--                </b-list-group-item>-->
            <!--                <b-list-group-item-->
            <!--                    :href="menuRoutes['cva']"-->
            <!--                    class="item sub-item"-->
            <!--                    :active="pageName === 'cva'"-->
            <!--                    @click="setPageName('cva')"-->
            <!--                >-->
            <!--                    <i class="fa-fw fal fa-table menu-sub-icon" />CVAE-->
            <!--                    <div class="float-right">-->
            <!--                        <counter-->
            <!--                            v-if="showCounters"-->
            <!--                            ref="cvaCounter"-->
            <!--                            :values="counters.cva"-->
            <!--                        />-->
            <!--                    </div>-->
            <!--                </b-list-group-item>-->
            <!--                <b-list-group-item-->
            <!--                    :href="menuRoutes['das']"-->
            <!--                    class="item sub-item"-->
            <!--                    :active="pageName === 'das'"-->
            <!--                    @click="setPageName('das')"-->
            <!--                >-->
            <!--                    <i class="fa-fw fal fa-table menu-sub-icon" />DAS2-->
            <!--                    <div class="float-right">-->
            <!--                        <counter-->
            <!--                            v-if="showCounters"-->
            <!--                            ref="dasCounter"-->
            <!--                            :values="counters.das"-->
            <!--                        />-->
            <!--                    </div>-->
            <!--                </b-list-group-item>-->
            <!--                <b-list-group-item-->
            <!--                    :href="menuRoutes['dsi']"-->
            <!--                    class="item sub-item"-->
            <!--                    :active="pageName === 'dsi'"-->
            <!--                    @click="setPageName('dsi')"-->
            <!--                >-->
            <!--                    <i class="fa-fw fal fa-table menu-sub-icon" />DSI-->
            <!--                    <div class="float-right">-->
            <!--                        <counter-->
            <!--                            v-if="showCounters"-->
            <!--                            ref="dsiCounter"-->
            <!--                            :values="counters.dsi"-->
            <!--                        />-->
            <!--                    </div>-->
            <!--                </b-list-group-item>-->
            <!--                <b-list-group-item-->
            <!--                    :href="menuRoutes['tvs']"-->
            <!--                    class="item sub-item"-->
            <!--                    :active="pageName === 'tvs'"-->
            <!--                    @click="setPageName('tvs')"-->
            <!--                >-->
            <!--                    <i class="fa-fw fal fa-table menu-sub-icon" />TVS-->
            <!--                    <div class="float-right">-->
            <!--                        <counter-->
            <!--                            v-if="showCounters"-->
            <!--                            ref="tvsCounter"-->
            <!--                            :values="counters.tvs"-->
            <!--                        />-->
            <!--                    </div>-->
            <!--                </b-list-group-item>-->
            <!--                <b-list-group-item-->
            <!--                    :href="menuRoutes['tss']"-->
            <!--                    class="item sub-item"-->
            <!--                    :active="pageName === 'tss'"-->
            <!--                    @click="setPageName('tss')"-->
            <!--                >-->
            <!--                    <i class="fa-fw fal fa-table menu-sub-icon" />Taxe sur-->
            <!--                    salaires-->
            <!--                    <div class="float-right">-->
            <!--                        <counter-->
            <!--                            v-if="showCounters"-->
            <!--                            ref="tscsCounter"-->
            <!--                            :values="counters.tss"-->
            <!--                        />-->
            <!--                    </div>-->
            <!--                </b-list-group-item>-->
            <!--            </b-collapse>-->

            <b-list-group-item
                :href="menuRoutes['cac']"
                class="item"
                :active="pageName === 'cac'"
                data-parent="#vMenu"
                @click="setPageName('cac')"
            ><i class="fa-fw fal fa-table menu-icon"/>CAC
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        ref="cacCounter"
                        :values="counters.cac"
                    />
                </div>
            </b-list-group-item>
            <data-filter/>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import counter from './counter'
import DataFilter from '../../../../common/components/DataFilterNew.vue'

export default {
    name: 'VerticalMenu',

    components: {
        DataFilter,
        counter
    },

    data() {
        return {
            openDeadlines: false,
            openOtherTax: false,
            openCharge: false,
            activeDeadlines: '',
            activeOtherTax: ''
        }
    },

    computed: {
        ...mapState({
            counters: (state) => state.reportingVM.counters,
            showCounters: (state) => state.reportingVM.showCounters,
            showVerticalMenu: (state) => state.reportingVM.showVerticalMenu,
            menuRoutes: (state) => state.reportingVM.menuRoutes,
            filters: (state) => state.reportingVM.filters,
            pageName: (state) => state.browsing.pageName
        })
    },

    async created() {
        this.$store.commit('reportingVM/HIDE_COUNTERS')
        await this.$store.dispatch('reportingVM/getRoutes')
        this.handleDeadlinesMenu()
        this.handleOtherTaxMenu()
    },

    methods: {
        setPageName(pageName) {
            this.$store.commit('browsing/SET_PAGE_NAME', pageName)
        },

        initOthPage() {
            // this.$store.commit('browsing/SET_OTHER_TAX_FILTER', 'oth')
            this.setPageName('oth')
        },

        handleDeadlinesMenu() {
            this.openDeadlines = ['soon', 'late'].includes(this.pageName)
            this.activeDeadlines = this.openDeadlines ? 'active' : ''
        },

        handleOtherTaxMenu() {
            this.openOtherTax = [
                'cfe',
                'cva',
                'das',
                'dsi',
                'tvs',
                'tss'
            ].includes(this.pageName)
            this.activeOtherTax = this.openOtherTax ? 'active' : ''
        }
    }
}
</script>

<style scoped>
.filter-type {
    font-size: 12px;
    font-weight: 600;
}
</style>
